import React from "react";
import { useFetcher } from "react-router-dom";
import ResponseBox from "../Demo/Response";
import { time_to_second } from "../Demo/utils/functions";
import { getRequestFromId } from "./data";
import { Spinner } from "./Spinner";

export async function loader({ params }) {
  const request = await getRequestFromId({ id: params.requestId });
  return request;
}

export const RequestPanel = ({ requestId }) => {
  const fetcher = useFetcher();
  let data = null;

  React.useEffect(() => {
    if (fetcher.state === "idle" && !fetcher.data) {
      fetcher.load(`/archive/requests/${requestId}`);
    }
  }, [fetcher, requestId]);

  if (fetcher.data) {
    const responseData = fetcher.data.response_data;
    console.log(fetcher.data);
    if (
      Array.isArray(responseData) &&
      responseData.length > 0 &&
      responseData[0].duration
    ) {
      data = {
        ...responseData[0],
        duration: time_to_second(responseData[0].duration),
      };
    }
  }

  if (!data) {
    return (
      <div className='request-pannel-loading'>
        <Spinner color='#c1c1c1' />
      </div>
    );
  }

  return (
    <ResponseBox finalResponse={data} wsConnected={false} isArchive={true} />
  );
};
